import { markAssignmentAsClosed } from "@/api/assignment";
import { RouteButton, OrangeButton } from "@/components/Buttons";
import { AssignmentProps } from "@/interfaces/assignment_types";
import { useAuth } from "@/App";
import { useState } from "react";
import { Error_Component } from "@/components/misc";

export function AssignmentRow({ data }: { data: AssignmentProps; }) {
    const { user } = useAuth()
    const [error, setError] = useState<string | null>(null)

    if (!user) {
        return <div>Loading...</div>
    }

    const handleMarkComplete = async () => {
        if (data.status === "Closed") {
            setError("Task is already complete");
            return;
        }

        if (confirm("Are you sure you want to mark this task as complete?")) {
            if (!data.id) {
                setError("Assignment ID is undefined");
                return;
            }
            const response = await markAssignmentAsClosed(data.id);
            if (response === 200) {
                window.location.reload();
            } else {
                setError("Error marking assignment as complete: " + response);
            }
        }
    };

    const encoded_id = encodeURIComponent(data.id || '');

    return (
        <div className="flex flex-col gap-2 p-2 bg-gray-100 ">
            {error && <Error_Component errorString={error}/>}
            <h2 className='mb-2 font-semibold'>Description:</h2>
            <p className="p-2 bg-gray-200 border-2 border-gray-300 rounded-md"> {data.description}</p>

            <h2 className='mb-2 font-semibold'>Category:</h2>
            <p className="p-2 bg-gray-200 border-2 border-gray-300 rounded-md"> {data.category}</p>

            <div className="flex flex-row gap-2 px-2">
                <RouteButton text="Edit Assignment" route={`/assignments/update_assignment/${encoded_id}`} />
                <OrangeButton onClick={handleMarkComplete}>Mark as Closed</OrangeButton>
            </div>
        </div>
    );
}
